// MODES registry (§19.3). Entries are getters, so a mode module that (indirectly) imports this
// registry while it is still loading never observes an uninitialized binding.
import { ModeId } from '../ids';
import { CROWN_GRAB } from './crownGrab';
import { HOT_POTATO } from './hotPotato';
import { LOBBY_MODE } from './lobbyMode';
import type { ModeRules } from './modeTypes';
import { PODIUM_MODE } from './podiumMode';
import { ROYALE } from './royale';

export const MODES: Readonly<Record<ModeId, ModeRules>> = {
  get [ModeId.LOBBY]() { return LOBBY_MODE; },
  get [ModeId.PODIUM]() { return PODIUM_MODE; },
  get [ModeId.ROYALE]() { return ROYALE; },
  get [ModeId.HOT_POTATO]() { return HOT_POTATO; },
  get [ModeId.CROWN_GRAB]() { return CROWN_GRAB; },
};
